import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("radar_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function download(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const dispo = res.headers?.["content-disposition"] || "";
  const m = /filename="?([^"]+)"?/.exec(dispo);
  const name = m ? m[1] : fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Erro inesperado";
}

export default api;
